import type { CompetitorSnapshot } from '../../../shared/types.ts';

/** Dia (YYYY-MM-DD) que uma rodada representa: o id da rodada, ou o dia da gravação. */
export const snapshotDay = (s: CompetitorSnapshot): string =>
  /^\d{4}-\d{2}-\d{2}$/.test(s.auditRound) ? s.auditRound : s.capturedAt.slice(0, 10);

/**
 * Linha de base de uma variação: a rodada anterior à última — recuando enquanto as rodadas
 * anteriores forem cópia uma da outra (o seed gravou 19 e 20/09 iguais), para a data exibida
 * ser a da coleta real e não a de uma cópia.
 */
export function baselineSnapshot(snapshots: CompetitorSnapshot[]): CompetitorSnapshot | null {
  let baseline: CompetitorSnapshot | null = null;
  for (let i = snapshots.length - 2; i >= 0; i--) {
    const s = snapshots[i]!;
    if (baseline && (s.followers !== baseline.followers || s.postsCount !== baseline.postsCount)) break;
    baseline = s;
  }
  return baseline;
}
